.widgetEditorWrapper {
  padding: 0 16px;
}

.widgetPanelSeparator {
  margin-top: auto;
}
